module.exports = __webpack_public_path__ + "static/media/brussels.31c15630.png";